export default "__VITE_ASSET__44rt8QyP__"